import React, { useEffect, useCallback, useRef } from "react";

function useEffectOnEscapeKey(handleEscapeKey: VoidFunction) {
  const handleUserKeyPress = useCallback(
    ({ keyCode }) => {
      if (keyCode === 27) {
        handleEscapeKey();
      }
    },
    [handleEscapeKey]
  );
  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);
}

function useEffectToDetectOutsideClick(
  ref: React.RefObject<HTMLDivElement>,
  handleClick: VoidFunction
) {
  useEffect(() => {
    function handleClickOutside(this: Document, event: MouseEvent) {
      if (
        ref.current &&
        event.target &&
        !ref.current.contains(event.target as Node)
      ) {
        handleClick();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, handleClick]);
}

export function useRefToDetectCloseEvents(handleClick: VoidFunction) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffectOnEscapeKey(handleClick);
  useEffectToDetectOutsideClick(containerRef, handleClick);
  return containerRef;
}
